import {Injectable} from '@angular/core';
import {Role} from '../../models/role.model';
import {SelectItem} from 'primeng/components/common/api';
import {HttpClientService} from '../httpClient/httpclient.service';

@Injectable()
export class RolesService {
  roles: Role[];

  base_url: string = "/koncentro-auth";
  rolesForDropdown: SelectItem[];

  constructor(private h: HttpClientService) {
    this.roles = [];
    this.rolesForDropdown = [];
  }


  getAll() {
    return this.h.get(this.base_url + "/users/roles")
      .map(res => {
        console.log(res)
        this.roles = res;



        this.rolesForDropdown = [{
          value: null,
          label: ""
        }];

        this.roles.forEach(function (r) {
          this.rolesForDropdown.push({
            value: r.id,
            label: r.descr
          });

        }, this);


        return res;
      });



  }

}



// WEBPACK FOOTER //
// ./src/app/services/user/roles.service.ts